export default {
  methods: {
    notificationToast({ message = '', variant = '', title = '' }) {
      this.$bvToast.toast(`${message}`, {
        toaster: 'b-toaster-top-center',
        title,
        autoHideDelay: 3000,
        appendToas: false,
        solid: true,
        variant,
      });
    },
    readOnlyUserNotificationToast() {
      this.$bvToast.toast(
        'If you believe this is an error, please contact your ATOM administrator.',
        {
          title: 'You have view-only privileges for this student.',
          autoHideDelay: 3000,
          appendToas: false,
          solid: true,
          variant: 'warning',
        },
      );
    },
  },
};
